<template lang="pug">
  .settingpage
    .right_col(role='main')
      .main_main_contents
        .page-title
          .title_left
            h2 個人設定
        .x_panel
          .x_content
            .row
              .col-xs-4
                label.h3 名前の変更
                .form-group
                  label.h5.control-label(for='name') 氏名
                  //現在の名前が入った状態
                  input#name.form-control(v-model='name' name='name' type='text' @blur='update' v-bind:class='{invalid:$v.name.$dirty && $v.name.$invalid}'
                  @input='$v.name.$touch')
                  span.error(v-show='$v.name.$dirty && $v.name.$invalid')
                    p(v-show='!$v.name.required') 必須項目です
                .form-group
                  label.h5.control-label(for='kana') フリガナ
                  //現在のフリガナが入った状態
                  input#kana.form-control(v-model='kana' name='kana' type='text' @blur='update' v-bind:class='{invalid:$v.kana.$dirty && $v.kana.$invalid}'
                  @input='$v.kana.$touch')
                  span.error(v-show='$v.kana.$dirty && $v.kana.$invalid')
                    p(v-show='!$v.kana.required') 必須項目です
                    p(v-show='!$v.kana.kana') 全角カナで入力してください
            .row
              .col-xs-10
                //登録済みの署名は表示した状態
                label.h3 署名設定
                h4 署名1
                .col-xs-4
                  .form-group
                    label.h5.control-label(for='title1') タイトル
                    input#title1.form-control(v-model='signature_title1' name='signature_title1' type='text' placeholder='（例）職場用' @blur='update' v-bind:class='{invalid:$v.signature_title1.$invalid}')
                    span.error(v-show='$v.signature_title1.$invalid')
                      p(v-show='!$v.signature_title1.maxLength') 50文字以下で入力してください
                .col-xs-8
                  .form-group
                    label.h5.control-label(for='signature1') 署名
                    textarea#signature1.form-control(v-model='signature1' name='signature1' type='text' rows='6' @blur='update')
                h4 署名2
                .col-xs-4
                  .form-group
                    label.h5.control-label(for='title2') タイトル
                    input#title2.form-control(v-model='signature_title2' name='signature_title2' type='text' placeholder='（例）プライベート用' @blur='update' v-bind:class='{invalid:$v.signature_title2.$invalid}')
                    span.error(v-show='$v.signature_title2.$invalid')
                      p(v-show='!$v.signature_title2.maxLength') 50文字以下で入力してください
                .col-xs-8
                  .form-group
                    label.h5.control-label(for='signature2') 署名
                    textarea#signature2.form-control(v-model='signature2' name='signature2' type='text' rows='6' @blur='update')
                h4 署名3
                .col-xs-4
                  .form-group
                    label.h5.control-label(for='title3') タイトル
                    input#title3.form-control(v-model='signature_title3' name='signature_title3' type='text' @blur='update' v-bind:class='{invalid:$v.signature_title3.$invalid}')
                    span.error(v-show='$v.signature_title3.$invalid')
                      p(v-show='!$v.signature_title3.maxLength') 50文字以下で入力してください
                .col-xs-8
                  .form-group
                    label.h5.control-label(for='signature3') 署名
                    textarea#signature3.form-control(v-model='signature3' name='signature3' type='text' rows='6' @blur='update')
                h4 デフォルト署名設定
                select.signselect.selectitems(v-model='default_signature' @blur='update')
                  option(value='') ---
                  option(v-bind:value='1' v-show='signature_title1 && signature1') {{signature_title1}}
                  option(v-bind:value='2' v-show='signature_title2 && signature2') {{signature_title2}}
                  option(v-bind:value='3' v-show='signature_title3 && signature3') {{signature_title3}}
            hr
            .row
              .col-xs-4
                label.h3 パスワード変更
                .form-group#password
                  label.h4.control-label(for='password') 現在のパスワード
                  input#password.form-control(v-model='password' type='text' placeholder='半角英数記号8文字以上で入力してください' @blur='passcheck')
                .form-group
                  label.h4.control-label(for='newpassword') 新しいパスワード
                  input#newpassword.form-control(v-model='newpassword' type='text' placeholder='半角英数記号8文字以上で入力してください' v-bind:class='{invalid:$v.newpassword.$invalid}')
                  span.error(v-show='$v.newpassword.$invalid')
                    p(v-show='!$v.newpassword.minLength') 8文字以上20文字以下で入力してください
                    p(v-show='!$v.newpassword.maxLength') 8文字以上20文字以下で入力してください
                    p(v-show='!$v.newpassword.ascii') 半角英数記号で入力してください
                .form-group
                  label.h4.control-label(for='repeatpassword') 新しいパスワード（確認用）
                  input#repeatpassword.form-control(v-model='repeatpassword' type='text' placeholder='半角英数記号8文字以上で入力してください'
                  v-bind:class='{invalid:$v.repeatpassword.$invalid}')
                  span(v-show='repeatpassword')
                    span.error(v-show='$v.repeatpassword.$invalid')
                      p(v-show='!$v.repeatpassword.sameAs') パスワードが一致しません
              .col-xs-1
                button.customsmallbutton.btn.btn-success.pass_savebutton(type='button' @click='passupdate') 変&nbsp;更
</template>

<script>
import $ from 'jquery'
import Authenticate from '@/service/Authenticate'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
import { ascii, kana } from '@/validators'

export default {
  data () {
    return {
      name: null,
      kana: null,
      signature1: null,
      signature2: null,
      signature3: null,
      signature_title1: null,
      signature_title2: null,
      signature_title3: null,
      default_signature: null,
      password: null,
      newpassword: null,
      repeatpassword: null,
      passvalid: false
    }
  },

  validations: {
    name: { required },
    kana: { required, kana },
    signature_title1: { maxLength: maxLength(50) },
    signature_title2: { maxLength: maxLength(50) },
    signature_title3: { maxLength: maxLength(50) },
    newpassword: { ascii, minLength: minLength(8), maxLength: maxLength(20) },
    repeatpassword: { sameAsPassword: sameAs('newpassword') }
  },

  mounted () {
    // 各項目をwatchして登録する
    this.$watch('name', function (val) {
      this.update()
    })
    this.$watch('kana', function (val) {
      this.update()
    })
    this.$watch('signature_title1', function (val) {
      this.update()
    })
    this.$watch('signature1', function (val) {
      this.update()
    })
    this.$watch('signature_title2', function (val) {
      this.update()
    })
    this.$watch('signature2', function (val) {
      this.update()
    })
    this.$watch('signature_title3', function (val) {
      this.update()
    })
    this.$watch('signature3', function (val) {
      this.update()
    })
    this.$watch('default_signature', function (val) {
      this.update()
    })

    // 新パスワードおよび新パスワード（確認用）をwatchして
    // 新パスワード（確認用）のエラー表示とスタイルを制御する
    this.$watch('newpassword', function (val) {
      if (!this.repeatpassword) {
        $('#repeatpassword').removeClass('invalid')
      }
    })
    this.$watch('repeatpassword', function (val) {
      if (!val) {
        $('#repeatpassword').removeClass('invalid')
      } else {
        // 確認用に値が入っていて、かつ一致エラーが発生している時
        if (this.$v.repeatpassword.$invalid) {
          $('#repeatpassword').addClass('invalid')
        }
      }
    })

    this.bind()
  },
  methods: {
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })
      let currentUser = Authenticate.currentUser()
      let axios = Request.instance(true)
      let result = axios.get('/user/' + currentUser.id)
      let vue = this
      result.then((res) => {
        // vue.$set(vue, 'contract', res.data)
        for (let key in res.data) {
          vue[key] = res.data[key]
        }
        vue.password = null
        this.$nextTick(() => { Loader.hide() })
      })
    },
    // updateする
    update () {
      // 入力チェック
      if (this.$v.name.$invalid || this.$v.kana.$invalid || this.$v.signature_title1.$invalid || this.$v.signature_title2.$invalid || this.$v.signature_title3.$invalid) {
        Message.show('error', ['入力内容に不備があります'])
        // 必須にtouchする
        this.$v.$touch()
        return false
      }

      // データ送信
      let axios = Request.instance(true)
      // let self = this
      axios.put('/user/' + this.id + '/update',
        qs.stringify({
          user: JSON.stringify(this._data)
        })
      ).then((res) => {
        // Message.show('success', ['更新しました'])
        // self.bind()
      }).catch((error) => {
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        alert(error.response.data.message)
      })
    },

    passcheck () {
      // 入力したパスワード取得
      let password = this.password
      // 入力が空であればなにもしない
      if (!password) {
        $('#passerror').remove()
        this.passvalid = false
        return false
      }
      // パスワード一致確認
      let axios = Request.instance(true)
      // let self = this
      axios.put('/user/' + this.id + '/passcheck',
        qs.stringify({
          password: password
        })
      ).then((res) => {
        if (res.data.valid) {
          $('#passerror').remove()
          this.passvalid = true
        } else {
          $('#passerror').remove()
          $('#password').append('<span id="passerror" class="error"></span>')
          $('#passerror').append('<p>' + res.data.message + '</p>')
          this.passvalid = false
        }
      }).catch((error) => {
        // dashboardへメッセージを送信
        alert(error.response.data.message)
      })
    },

    // パスワード更新
    passupdate () {
      // 入力チェック
      if (this.$v.newpassword.$invalid || this.$v.repeatpassword.$invalid || !this.passvalid) {
        Message.show('error', ['入力内容に不備があります'])
        return false
      }
      // データ送信
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let self = this
      axios.put('/user/' + this.id + '/passupdate',
        qs.stringify({
          password: this.newpassword
        })
      ).then((res) => {
        Message.show('success', ['更新しました'])
        self.newpassword = null
        self.repeatpassword = null
        self.bind()
      }).catch((error) => {
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        alert(error.response.data.message)
      })
    }
  },
  components: {
  }
}
</script>

<style lang="stylus" scoped>
.name_savebutton
  margin-top: 48px
.pass_savebutton
  margin-top: 238px
.sign_savebutton
  text-align: right
#signature1, #signature2, #signature3
  resize: vertical
.signselect
  height: 25px
</style>



// WEBPACK FOOTER //
// UserSettings.vue?24a97e8c